var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDrug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5796_52172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5402 6.01988C28.6535 5.24988 27.3235 5.24988 26.4368 6.01988C15.0502 16.0532 9.3335 24.7799 9.3335 32.1999C9.3335 43.8199 18.2002 51.3332 28.0002 51.3332C37.8002 51.3332 46.6668 43.8199 46.6668 32.1999C46.6668 24.7799 40.9502 16.0532 29.5402 6.01988ZM32.6668 41.9999H23.3335C22.0502 41.9999 21.0002 40.9499 21.0002 39.6665C21.0002 38.3832 22.0502 37.3332 23.3335 37.3332H32.6668C33.9502 37.3332 35.0002 38.3832 35.0002 39.6665C35.0002 40.9499 33.9502 41.9999 32.6668 41.9999ZM32.6668 30.3332H30.3335V32.6665C30.3335 33.9499 29.2835 34.9999 28.0002 34.9999C26.7168 34.9999 25.6668 33.9499 25.6668 32.6665V30.3332H23.3335C22.0502 30.3332 21.0002 29.2832 21.0002 27.9999C21.0002 26.7166 22.0502 25.6665 23.3335 25.6665H25.6668V23.3332C25.6668 22.0499 26.7168 20.9999 28.0002 20.9999C29.2835 20.9999 30.3335 22.0499 30.3335 23.3332V25.6665H32.6668C33.9502 25.6665 35.0002 26.7166 35.0002 27.9999C35.0002 29.2832 33.9502 30.3332 32.6668 30.3332Z",
    fill: "#1A9CC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5796_52172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrug);
export default __webpack_public_path__ + "static/media/icon-drug.c74f460ffd981b6bbcb08ff03618581c.svg";
export { ForwardRef as ReactComponent };